import React from 'react'
import { Alert } from 'react-bootstrap'
import carta from '../../assets/files/Carta-compromiso-de-entrega-de-Certificado.docx'
import prorroga from '../../assets/files/prorroga.docx'
import prorrogaPosgrado from '../../assets/files/prorroga-posgrado.docx'
import contratoEstudiante from '../../assets/files/carta-compromiso-estudiante.pdf'
import solicitudInscripcionMaestria from '../../assets/files/solicitud-inscripcion-posgrado.pdf'
import solicitudInscripcionDoctorado from '../../assets/files/solicitud-inscripcion-posgrado.pdf'
import solicitudInscripcionLicenciatura from '../../assets/files/solicitud-inscripcion-licenciatura.pdf'
import cartaConsentimientoDatosPersonales from '../../assets/files/carta-consentimiento-datos-personales.pdf'

const DocumentMessages = ({ slug, equivalencia }) => {

  switch (slug) {
    case 'solicitud-de-inscripcion':
      return (
        <Alert className="mt-1" variant="info">
          Descarga la <strong>Solicitud de Inscripci&oacute;n</strong> <a href={solicitudInscripcionLicenciatura} download><strong>aqui</strong></a> y ll&eacute;nala. Asegúrate de llenar todos los datos que se piden y s&uacute;bela en este apartado. No se te olvide llenar la fecha y firmar el documento.
        </Alert>
      )

    case 'solicitud-de-inscripcion-maestria':
      return (
        <Alert className="mt-1" variant="info">
          Descarga la <strong>Solicitud de Inscripci&oacute;n <a href={solicitudInscripcionMaestria} download>aqui</a></strong> y ll&eacute;nala. Asegúrate de llenar todos los datos que se piden y súbela en este apartado. No se te olvide llenar la fecha y firmar el documento.
        </Alert>
      )

    case 'solicitud-de-inscripcion-doctorado':
      return (
        <Alert className="mt-1" variant="info">
          Descarga la <strong>Solicitud de Inscripci&oacute;n</strong> <strong><a href={solicitudInscripcionDoctorado} download>aqui</a></strong> y ll&eacute;nala. Asegúrate de llenar todos los datos que se piden y s&uacute;bela en este apartado. No se te olvide llenar la fecha y firmar el documento.
        </Alert>
      )

    case 'carta-de-consentimiento-para-el-tratamiento-de-datos-personales':
      return (
        <Alert className="mt-1" variant="info">
          Descarga la <strong>Carta de consentimiento para el tratamiento de datos personales</strong> <strong><a href={cartaConsentimientoDatosPersonales} download>aqui</a></strong> y ll&eacute;nala. Asegúrate de llenar todos los datos que se piden y s&uacute;bela en este apartado. No se te olvide llenar la fecha y firmar el documento.
        </Alert>
      )

    case 'contrato-con-el-estudiante':
      return (
        <Alert className="mt-1" variant="info">
          Descarga la <strong>Carta compromiso con el Estudiante</strong> <a href={contratoEstudiante} download><strong>aqui</strong></a> y ll&eacute;nala. Asegúrate de llenar todos los datos que se piden y s&uacute;bela en este apartado. No se te olvide llenar la fecha y firmar el documento.
        </Alert>
      )

    case 'forma-fm9':
      return (
        <Alert className="mt-1" variant="info">
          <strong>Opcional.</strong> En caso de ser <strong>extranjero</strong> es obligatorio que subas la <strong>Forma FM9</strong>.
        </Alert>
      )

    case 'fotografia':
      return (
        <Alert className="mt-1" variant="info">
          <strong>Opcional.</strong> Ya no es obligatorio que proporciones tu fotografía.
        </Alert>
      )

    case 'kardex-de-preparatoria':
      return (
        <Alert className="mt-1" variant="info">
          <strong>Opcional. </strong>En caso de no contar con el <strong>Certificado de Bachillerato</strong> es obligatorio que subas aqui tu <strong>K&aacute;rdex de Preparatoria</strong>.
        </Alert>
      )

    case 'kardex-de-licenciatura':
      return (
        <Alert className='mt-1' variant='info'>
          <strong>Opcional.</strong> En caso de no contar con el <strong>Certificado de Licenciatura</strong> es obligatorio que subas aquí tu <strong>Kárdex de Licenciatura</strong>.
        </Alert>
      )

    case 'kardex-de-maestria':
      return (
        <Alert className='mt-1' variant='info'>
          <strong>Opcional.</strong> En caso de no contar con el <strong>Certificado de Maestría</strong> es obligatorio que subas aquí tu <strong>Kárdex de Maestría</strong> y lo indiques en la <strong>Carta Compromiso</strong>.
        </Alert>
      )

    case 'constancia-de-estudios':
      return (
        <Alert className="mt-1" variant="info">
          <strong>Opcional. </strong>En caso de no contar con el <strong>Certificado de Bachillerato</strong> es obligatorio que subas aqui tu <strong>Constancia de Estudios</strong>.
        </Alert>
      )

    case 'certificado-de-bachillerato':
      return (
        <Alert className="mt-1" variant="info">
          En caso de no contar con el <strong>Certificado de Bachillerato</strong> sigue los siguientes pasos:
          <ol>
            <li>Descarga la <strong>Prorroga</strong> <a href={prorroga} download><b>aqui</b></a> y ll&eacute;nala.</li>
            <li>Guarda la <strong>Prorroga</strong> como PDF y s&uacute;bela en este apartado.</li>
            <li>Sube tu <strong>Constancia de Estudios</strong> en el apartado correspondiente.</li>
            <li>Sube tu <strong>K&aacute;rdex de Preparatoria</strong> en el apartado correspondiente.</li>
          </ol>
        </Alert>
      )

    case 'certificado-de-licenciatura':
      return (
        <Alert className='mt-1' variant='info'>
          En caso de no contar con el <strong>Certificado de Licenciatura, Título Profesional y/o Cédula Profesional</strong> sigue los siguientes pasos:
          <ol>
            <li>Descarga la <strong>Prorroga <a href={prorrogaPosgrado} download>aqui</a></strong> y llénala. RECUERDA INDICAR TODOS LOS DOCUMENTOS A DEBER.</li>
            <li>Guarda la <strong>Prorroga</strong> como PDF y súbela en este apartado.</li>
            <li>Sube tu <strong>Kárdex de Licenciatura</strong> en el apartado correspondiente.</li>
          </ol>
        </Alert>
      )

    case 'certificado-de-maestria':
      return (
        <Alert className='mt-1' variant='info'>
          En caso de no contar con el <strong>Certificado de Maestría, Título de Grado y/o Cédula Profesional</strong> sigue los siguientes pasos:
          <ol>
            <li>Descarga la <strong>Prorroga <a href={prorrogaPosgrado} download>aqui</a></strong> y llénala. RECUERDA INDICAR TODOS LOS DOCUMENTOS A DEBER.</li>
            <li>Guarda la <strong>Prorroga como</strong> PDF y súbela en este apartado.</li>
            <li>Sube tu <strong>Kárdex de Maestría</strong> en el apartado correspondiente.</li>
          </ol>
        </Alert>
      )

    case 'titulo-profesional':
      return (
        <Alert className='mt-1' variant='info'>
          <strong>Opcional.</strong> En caso de no contar con el <strong>Título Profesional</strong> es necesario que lo indiques en la <strong>Carta Compromiso</strong>.
        </Alert>
      )

    case 'cedula-profesional':
      return (
        <Alert className='mt-1' variant='info'>
          <strong>Opcional.</strong> En caso de no contar con la <strong>C&eacute;dula Profesional</strong> es necesario que lo indiques en la <strong>Carta Compromiso</strong>.
        </Alert>
      )

    case 'dictamen-de-revalidacion':
      return (
        <Alert className='mt-1' variant='info'>
          <strong>Opcional.</strong> En caso de ser <strong>extranjero</strong> es obligatorio que subas el <strong>Dictamen de Revalidación</strong>.
        </Alert>
      )

    case 'certificado-medico':
      return (
        <Alert className='mt-1' variant='info'>
          En caso de no contar con el <strong>Certificado Médico</strong> sigue los siguientes pasos:
          <ol>
            <li>Descarga la <strong>Prorroga <a href={prorroga} download>aqui</a></strong> y llénala indicando en OTRO el <strong>Certificado Médico</strong>.</li>
            <li>Guarda la <strong>Prorroga</strong> como PDF y súbela en este apartado.</li>
          </ol>
        </Alert>
      )
    case 'titulo-de-grado':
      return (
        <Alert className='mt-1' variant="info">
          <strong>Opcional.</strong> En caso de no contar con el <strong>Título de Grado</strong> es necesario que lo indiques en la <strong>Carta Compromiso</strong>.
        </Alert>
      )

    case 'pago-de-formato-sat-no-5':
      return equivalencia ? (<></>) : (
        <Alert className='mt-1' variant='info'>
          <strong>Opcional.</strong> En caso de ser extranjero es obligatorio que subas el <strong>Pago de Formato SAT NO.5.</strong>
        </Alert>
      )

    case 'analisis-tecnico':
      return equivalencia ? (<></>) : (
        <Alert className='mt-1' variant='info'>
          <strong>Opcional.</strong> En caso de ser <strong>extranjero</strong> es obligatorio que subas el <strong>Análisis Técnico.</strong>
        </Alert>
      )

    case 'certificado-parcial-de-licenciatura':
      return (
        <Alert className='mt-1' variant='info'>
          En caso de no contar con el <strong>Certificado Parcial de Licenciatura</strong> sigue los siguientes pasos:
          <ol>
            <li>Descarga la <strong>Prorroga <a href={prorroga} downolad>aqui</a></strong> y llénala indicando en OTRO el <strong>Certificado Parcial de Licenciatura</strong>.</li>
            <li>Guarda la <strong>Prorroga</strong> como PDF y súbela en este apartado.</li>
            <li>Sube tu <strong>Constancia de Certificado Parcial de Licenciatura en Trámite</strong> en el apartado correspondiente.</li>
            <li>Sube tu <strong>Kárdex Parcial de Licenciatura</strong> en el apartado correspondiente.</li>
          </ol>
        </Alert>
      )

    case 'constancia-de-certificado-parcial-de-licenciatura-en-tramite':
      return (
        <Alert className='mt-1' variant='info'>
          <strong>Opcional.</strong> En caso de no contar con el <strong>Certificado Parcial de Licenciatura</strong> es obligatorio que subas aquí tu <strong>Constancia de Certificado Parcial de Licenciatura en Trámite.</strong>
        </Alert>
      )

    case 'kardex-parcial-de-licenciatura':
      return (
        <Alert className='mt-1' variant='info'>
          <strong>Opcional.</strong> En caso de no contar con el <strong>Certificado Parcial de Licenciatura</strong> es obligatorio que subas aquí tu <strong>Kárdex Parcial de Licenciatura.</strong>
        </Alert>
      )

    default:
      return null
  }
}

export default DocumentMessages